import { ACTIONS } from '_redux/actions';

const initialState = {
  content: {
    navigationItems: [],
  },
  contentLoading: true,
};

export default function navigation(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.NAVIGATION.FETCH_NAVIGATION:
      return {
        ...state,
        contentLoading: true,
      };

    case ACTIONS.NAVIGATION.FETCH_NAVIGATION_SUCCESS:
      return {
        ...state,
        content: {
          ...action.payload.data,
        },
        contentLoading: false,
      };

    default:
      return state;
  }
}
